import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { NotificationAPIService } from 'src/app/extensions/services/api/notification-api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public constructor(private _toastrService: ToastrService) {}

  public showSuccess(message: string, title: string, url?: string) {
    let options: Partial<IndividualConfig<any>> = {
      disableTimeOut: !!url,
      tapToDismiss: !url,
    };
    if (url) {
      options = { ...options, payload: { viewMoreAction: () => this.toasterClickedHandler(url) } };
    }
    this._toastrService.success(message, title, options);
  }

  public showError(message: string, title: string, url?: string) {
    let options: Partial<IndividualConfig<any>> = {
      disableTimeOut: !!url,
      tapToDismiss: !url,
    };

    if (url) {
      options = { ...options, payload: { viewMoreAction: () => this.toasterClickedHandler(url) } };
    }
    this._toastrService.error(message, title, options);
  }

  public showWarning(message: string, title: string, url?: string) {
    let options: Partial<IndividualConfig<any>> = {
      disableTimeOut: !!url,
      tapToDismiss: !url,
      enableHtml: true,
    };

    if (url) {
      options = { ...options, payload: { viewMoreAction: () => this.toasterClickedHandler(url) } };
    }
    this._toastrService.warning(message, title, options);
  }

  public showInfo(
    message: string,
    title: string,
    url?: string,
    markAsRead: boolean = false,
    urlParams: string = '',
    _notificationAPIService: NotificationAPIService = null
  ) {
    let options: Partial<IndividualConfig<any>> = {
      disableTimeOut: !!url,
      tapToDismiss: !url,
      enableHtml: true,
    };

    if (url) {
      options = {
        ...options,
        payload: {
          viewMoreAction: async () => this.toasterClickedHandler(url, markAsRead, urlParams, _notificationAPIService),
        },
      };
    }

    this._toastrService.info(message, title, options);
  }

  private async toasterClickedHandler(
    url: string,
    markAsReadAction: boolean = false,
    urlParams: string = '',
    _notificationAPIService: NotificationAPIService = null
  ) {
    if (markAsReadAction && _notificationAPIService != null) {
      await _notificationAPIService.markNotificationsAsRead(new Array(urlParams)).toPromise();
    }

    if (url) {
      window.location.href = url;
    }
  }
}
